import React, { useState, useEffect } from "react";
import shop from "../../images/shop.png";
import { Link } from "react-router-dom";
import { Box, Button, Stack, styled, TextField } from "@mui/material";
import { Grid, Typography } from "@mui/material";
import ShopsRepository from "../../Repository/ShopsRepository";
import Loader from "../components/Loader";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import DialogComponent from "../reusableComponents/Dialog";
import { toast } from "react-toastify";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import Search from "../components/Search";
import add from "../../images/add.svg";
import { Toast } from "../components/Toast";

const ItemBox = styled(Grid)({
  // position: "relative",
  background: "white",
  padding: "2px 10px",
  marginTop: "5px",
  height: "60px",
  boxShadow: "0px 3px 6px #00000029",
  borderRadius: "7px",
  display: "flex",
  alignItems: "center",
});
const ButtonBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-evenly",
}));

function Warehouses() {
  const [state, setState] = useState({
    searchText: "",
    shop_title: "",
    open: false,
    selected_shop: {},
    warehouses: [],
    addModal: false,
    deleteModal: false,
    updateModal: false,
    isnew: false,
    id: "",
    selected: "",
    updateTitle: "",
  });

  useEffect(() => {
    getShops();
  }, []);

  const toggle = (name) => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };
  const getShops = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await ShopsRepository.shopsModel({
      request: {
        method: "getShopsByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    let warehouses = data.response.data.shops;
    setState((prev) => ({ ...prev, warehouses, loading: false }));
  };
  const saveNewShop = async () => {
    try {
      if (!state.shop_title) {
        toast.configure();
        toast.info("Add Warehouse Title");
        return;
      }
      toggle("addModal");

      let { data } = await ShopsRepository.shopsModel({
        request: {
          method: "saveShop",
          data: {
            shop: {
              shop_code: Math.floor(Math.random() * 100000000000 + 100000000),
              company_code: localStorage.getItem("companyCode"),
              shopName: state.shop_title,
            },
          },
        },
      });
      if (data.response.data.shop) {
        toast.configure();
        toast.success("Warehouse Added Successfully");
        getShops();
      } else {
        toast.configure();
        toast.error("Warehouse Not Added");
      }
    } catch (err) {
      console.log(err);
    }
  };
  const deleteShop = async () => {
    toggle("deleteModal");
    let { data } = await ShopsRepository.shopsModel({
      request: {
        method: "deleteShop",
        data: {
          _id: state.id,
        },
      },
    });
    console.log(data);

    getShops();
  };
  const updateWarehouse = async () => {
    toggle("updateModal");
    try {
      await ShopsRepository.shopsModel({
        request: {
          method: "updateShop",
          data: {
            shop: { ...state.selected, shopName: state.updateTitle },
          },
        },
      });
      Toast("success", "Updated Successfully");
      getShops();
    } catch (err) {
      console.log(err);
      Toast("error", "Error");
      getShops();
    }
  };

  const handleClickOpen = (id) => {
    setState((prev) => ({ ...prev, id, deleteModal: true }));
  };
  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = (item) => {
    setState((prev) => ({
      ...prev,
      updateTitle: item.shopName,
      selected: item,
      updateModal: true,
    }));
  };

  const searchItems = () => {
    if (state.searchText) {
      const filtered = state.warehouses.filter((item) =>
        item.shopName.toLowerCase().includes(state.searchText)
      );
      return filtered;
    } else {
      return state.warehouses;
    }
  };

  return (
    <Box sx={{ pb: 5, mt: 5 }}>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center">
          <Grid item md={3} xs={12}>
            <Search
              name={"searchText"}
              text={"Search warehouse..."}
              value={state.searchText}
              onChange={handleInput}
            />
          </Grid>
          <Grid align="center" item md={8} xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "white", fontSize: { md: "1.5rem", xs: "16px" } }}
            >
              Warehouses
            </Typography>
          </Grid>
          <Grid align="center" item md={1} xs={12}>
            <ButtonAdd
              variant="contained"
              sx={{ width: { md: "100%", xs: "80%" } }}
              onClick={() => toggle("addModal")}
            >
              Add <img src={add} alt="add" />
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer>
        {searchItems().map((item, index) => {
          return (
            <ItemBox key={index} container spacing={1}>
              <Grid item xs={1}>
                {index + 1}
              </Grid>
              <Grid item xs={4}>
                <Link
                  to={{
                    pathname: "/inventory/admin/warehouse-detail",
                    state: {
                      shop_code: item.shop_code,
                      shopName: item.shopName,
                      shops: state.warehouses,
                    },
                  }}
                >
                  <Typography
                    sx={{ color: "#4eaf51", textDecoration: "undeline" }}
                  >
                    {item.shopName}
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={7}>
                <ButtonBox>
                  <Button
                    variant="contained"
                    onClick={() => handleEdit(item)}
                    sx={{ width: { md: "auto", xs: "20px" } }}
                  >
                    <i style={{ color: "white" }} className="fas fa-edit"></i>
                  </Button>

                  <Button
                    variant="contained"
                    onClick={() => handleClickOpen(item._id)}
                    sx={{
                      width: { md: "auto", xs: "20px" },
                      background: "red !important",
                    }}
                  >
                    <i style={{ color: "white" }} className="fas fa-trash"></i>
                  </Button>
                </ButtonBox>
              </Grid>
            </ItemBox>
          );
        })}
        {state.warehouses.length == 0 && !state.loading && (
          <Stack alignItems="center" justifyContent="space-evenly">
            <img src={shop} alt="" />
            <Typography sx={{ color: "#757575", fontWeight: "800" }}>
              Create your warehouse now
            </Typography>
          </Stack>
        )}
        <Loader loading={state.loading} />
      </BodyContainer>
      <DeleteDialog
        title="Delete Warehouse"
        open={state.deleteModal}
        onClose={() => toggle("deleteModal")}
        onClickYes={deleteShop}
      />
      <DialogComponent
        title="Add Warehouse"
        open={state.updateModal}
        onClose={() => toggle("updateModal")}
        onClickCancel={() => toggle("updateModal")}
        dialogContent={
          <Stack gap={2}>
            <Typography variant="h6" sx={{ color: "#4eaf51" }}>
              Update Warehouse Title
            </Typography>
            <TextField
              autoFocus
              variant="outlined"
              name="updateTitle"
              value={state.updateTitle}
              onChange={handleInput}
              label="Warehouse Name"
              fullWidth
            />
            <Stack direction="row" justifyContent="space-between" spacing={5}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => toggle("updateModal")}
                sx={{ color: "white", background: "#8A8A8A !important" }}
              >
                Cancel
              </Button>
              <Button fullWidth onClick={updateWarehouse} variant="contained">
                Update
              </Button>
            </Stack>
          </Stack>
        }
      />
      <DialogComponent
        title="Add Warehouse"
        open={state.addModal}
        onClose={() => toggle("addModal")}
        onClickCancel={() => toggle("addModal")}
        dialogContent={
          <Stack gap={2}>
            <Typography variant="h6" sx={{ color: "#4eaf51" }}>
              New Warehouse
            </Typography>
            <TextField
              autoFocus
              variant="outlined"
              name="shop_title"
              value={state.shop_title}
              onChange={handleInput}
              label="Warehouse Name"
              fullWidth
            />
            <Stack direction="row" justifyContent="space-between" spacing={5}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => toggle("addModal")}
                sx={{ color: "white", background: "#8A8A8A !important" }}
              >
                Cancel
              </Button>
              <Button fullWidth onClick={saveNewShop} variant="contained">
                Add
              </Button>
            </Stack>
          </Stack>
        }
      />
    </Box>
  );
}

export default Warehouses;
